import { invertStrObj } from '@Utils/invertObj';
import { RequisitionRequestTypeCodes } from '@Enum/api/RequestTypeCodes.enum';
import FeatureRoutePath from '../MRFeatureRoutePath.enum';

export const RequestTypePerPath: { [key: string]: string } = {
  [RequisitionRequestTypeCodes.PURCHASE_REQUEST]:
    FeatureRoutePath.PROCUREMENT_PURCHASE_REQUEST,
  [RequisitionRequestTypeCodes.TENDER_REQUEST]:
    FeatureRoutePath.PROCUREMENT_TENDER_REQUEST,
};

export const RequestPathPerType = invertStrObj(RequestTypePerPath);
